import type { YachtGameState, YachtToggleHoldAction } from "../types";
import { replaceHeld } from "../utils";

export function applyToggleHold(
  state: YachtGameState,
  action: YachtToggleHoldAction,
): YachtGameState {
  const slot = state.turnSlotsByPlayerId[action.playerId];
  if (!slot) return state;

  return {
    ...state,
    turnSlotsByPlayerId: {
      ...state.turnSlotsByPlayerId,
      [action.playerId]: {
        ...slot,
        held: replaceHeld(
          slot.held,
          action.dieIndex,
          !slot.held[action.dieIndex],
        ),
      },
    },
  };
}
